import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { applyTheme } from './applyTheme.js';
import { ColorModeProvider } from './ColorModeProvider.js';
export function ThemeProvider({ theme, children }) {
    useEffect(() => {
        applyTheme(theme);
    }, [theme]);
    return _jsx(ColorModeProvider, { theme: theme, children: children });
}
//# sourceMappingURL=ThemeProvider.js.map